import React from 'react';
import { ContentCopy as CopyIcon } from 'mdi-material-ui';
import { IconButton, IconButtonProps } from '../IconButton';
import { useCopyToClipboard } from '../../utils/useCopyToClipboard';

export type CopyToClipboardButtonProps = Omit<
  IconButtonProps,
  | 'onClick'
  | 'form'
  | 'formAction'
  | 'formEncType'
  | 'formMethod'
  | 'formNoValidate'
  | 'formTarget'
  | 'danger'
  | 'Badge'
  | 'type'
  | 'value'
  | 'component'
> & {
  valueToCopy: string;
  innerSx?: IconButtonProps['sx'];
};

/**
 * Button that will copy the 'valueToCopy' prop's value to the clipboard when
 * clicked.
 */
export function CopyToClipboardButton({
  valueToCopy,
  innerSx,
  variant = 'secondary',
  ...props
}: CopyToClipboardButtonProps) {
  const copy = useCopyToClipboard();

  return (
    <IconButton
      title="copy-to-clipboard"
      variant={variant}
      onClick={async (e) => {
        try {
          e.preventDefault();
          e.stopPropagation();
          await copy(valueToCopy);
        } catch (_error) {
          // Error is handled by the hook (shows snackbar), we just need to catch it here
          // to prevent unhandled promise rejections
        }
      }}
      {...props}
    >
      <CopyIcon sx={innerSx} />
    </IconButton>
  );
}
